import React, { createContext, useState, useEffect, useContext } from 'react';
import { GET_PARTNER } from '../../../data/url';
import httpClient from '../../../http/HttpRequest';

const UserContext = createContext();

export const useUserContext = () => {
     return useContext(UserContext);
};

export const UserProvider = ({ children }) => {
     const [userData, setUserData] = useState({});

     useEffect(() => {
          getUser();
     }, [])

     const getUser = async (e) => {
          try {
               const res = await httpClient.post(GET_PARTNER, {});
               if (res.requestStatus === 'OK' && res.result.status === 1) {
                    setUserData(res.result.data);                   
               }
          } catch (error) {
               console.error('User error:', error);
          }
     }

     return (
          <UserContext.Provider value={{ userData }}>
               {children}
          </UserContext.Provider>
     );
};